import React, { useState, useContext } from "react"
import VisibilitySensor from "react-visibility-sensor"
import { UIContext } from "../../../src/components/shared/layout"

import styled from "styled-components"
import { FadeIn, FadeInBottom } from "../styles/animations.styles"
export {FadeIn, FadeInBottom}

export const withAnimation = WrappedComponent => {
  const StyledElement = styled(WrappedComponent)`
    animation: ${props => !props.disableAnimations && props.animation};
    animation-play-state: ${props => (props.isVisible ? "running" : "paused")};
    animation-duration: ${props => props.duration ?? "1s"};
    animation-timing-function: ${props => props.timingFunction ?? "ease"};
    animation-delay: ${props => props.delay ?? "0s"};
    animation-fill-mode: ${props => props.fillMode ?? "both"};
  `

  return ({
    children,
    fullyVisible = false,
    onChange = () => null,
    animation = FadeIn,
    duration = "1s",
    timingFunction = "ease",
    delay = "0s",
    ...rest
  }) => {
    const [isVisible, _setIsVisible] = useState(false)
    const {
      state: { disableAnimations },
    } = useContext(UIContext)

    const setIsVisible = state => {
      if (state) {
        onChange(state)
        _setIsVisible(state)
      }
    }

    return (
      <VisibilitySensor
        partialVisibility={!fullyVisible}
        onChange={setIsVisible}
      >
        <StyledElement
          disableAnimations={disableAnimations}
          animation={animation}
          duration={duration}
          timingFunction={timingFunction}
          delay={delay}
          {...rest}
          isVisible={isVisible}
        >
          {children}
        </StyledElement>
      </VisibilitySensor>
    )
  }
}

export default withAnimation
